/// <reference path="Strings-vsdoc.js" />
/* global webAdBaseUrl, Strings, jjk */
/* exported getUrlForActionMitPlatzhaltern, post_form_ajax, submit_form_default, set_before_submit, scroll_to_weiter, scroll_to_element, triggerChange, equal_height, convert2BootstrapCheckboxOrRadiobutton,
			isBootstrapAvailable, setTooltips, createDialogTemplate, inKundenRolleSchluepfen, ArrayHasValue, convert2BootstrapCheckboxOrRadiobutton_geladen, set_before_submit_async */

window.JJK = window.JJK || {};

function getUrlForActionMitPlatzhaltern(url, obj) {
	for (let property in obj) {
		if (!Object.prototype.hasOwnProperty.call(obj, property)) {
			continue;
		} // siehe: https://eslint.org/docs/rules/guard-for-in
		const search = `{{${property}}}`;
		if (url.indexOf(search) <= 0) {
			throw `Keinen Platzhalter für "${property}" in URL gefunden!`;
		}
		url = url.replace(search, obj[property]);
	}
	const uebrigePlatzhalter = url.match(/{{[^}]*}}/g);
	if (uebrigePlatzhalter && uebrigePlatzhalter.length) {
		throw `Folgende Platzhalter wurden nicht ersetzte: ${uebrigePlatzhalter.join(', ')}`;
	}
	return url;
}

function post_form_ajax(formId) {
	/// <summary>Sendet die Form per Ajax an den Server und ersetzt den Content und den Progress der Seite mit dem aus dem Response</summary>
	/// <param name="formId">Id der Form, die geposted werden soll</param>
	'use strict';
	const scrim = new JJK.UI.ScrimmedMessage(`<img src="${webAdBaseUrl}Content/images/ajax_loader.gif" />`, Strings.DatenUebertragen, `scrim_${formId}`);
	scrim.show();
	return $.post($(`#${formId}`).get(0).action, $(`#${formId}`).serialize(), 'text')
		.done(function (data) {
			if (typeof data == 'object' && data.redirectUrl) {
				window.location.href = data.redirectUrl;
				return;
			}
			// data muss gefiltert werden, da der IE sonst CSS/JS Dateien aus dem <head> lädt und sich daran verschluckt:
			const responseHtmlBodyContent = data.match(/<body[^>]*>([^]*)<\/body/m)[1];

			if (!responseHtmlBodyContent) {
				alert(Strings.AjaxFehler);
				return;
			}

			if ($('#content', responseHtmlBodyContent).length) {
				// neues Design
				$('#content').html($('#content', responseHtmlBodyContent).html());
				$('#progress').html($('#progress', responseHtmlBodyContent).html());
				$('#WerbungNavigation').html($('#WerbungNavigation', responseHtmlBodyContent).html());
			} else if ($('#wb_contentbox', responseHtmlBodyContent).length) {
				// altes Design
				$('#wb_contentbox').html($('#wb_contentbox', responseHtmlBodyContent).html());
				$('.wb_navbox_top_parent').html($('.wb_navbox_top_parent', responseHtmlBodyContent).html());
			} else {
				alert(Strings.AjaxFehler);
			}
		})
		.fail(function (jqXhr, textStatus, errorThrown) {
			console.log(`Fehler bei der Serverkommunikation: ${textStatus}\n${errorThrown}`); // eslint-disable-line no-console
			alert(Strings.AjaxFehler);
		})
		.always(function () {
			scrim.hide();
		});
}

function submit_form_default(navigateTo, formId) {
	return submit_form_action(navigateTo, formId);
}

function submit_form(navigateTo, formId, action) {
	return submit_form_action(navigateTo, formId, action || 'Submit');
}

function triggerChange(...selectors) {
	for (const selector of selectors) {
		$(selector).triggerHandler('change');
	}
}

async function submit_form_action(navigateTo, formId, action) {
	///	<param name="navigateTo" type="String"/>
	if (window.submit_form_called) {
		return;
	}
	if (navigateTo) {
		$('#NavigateTo').val(navigateTo);
	}
	if (window.form_before_submit && window.form_before_submit[formId]) {
		if (window.form_before_submit[formId](formId, action, window.Formular) === false) {
			return;
		}
	}
	if (window.form_before_submit_async && window.form_before_submit_async[formId]) {
		try {
			if ((await Promise.all(window.form_before_submit_async[formId].map(func => func(formId, action, window.Formular)))).some(result => result === false)) {
				return;
			}
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error(err);
			alert('Fehler beim Vorbereiten der Daten vor dem Absenden zum Server.');
			return;
		}
	}

	if (typeof window.before_submit === 'function') {
		if (window.before_submit(formId, action) === false) {
			return;
		}
	}

	if (typeof formId === 'undefined' || $('form[action]', '.jjk-webinnovations-container').length === 1) {
		for (let i = 0; i < document.forms.length; i++) {
			if (document.forms[i].getAttribute('action')) {
				formId = i;
				break;
			}
		}
	}

	window.submit_form_called = true;
	const formHtmlElem =
		typeof formId == 'number'
			? $('form', '.jjk-webinnovations-container').get(formId) || $('form', 'body').get(formId) //Fallback auf body, da Landingspages auch freies HTML haben können und die Verlage oder deren Dienstleister dann sicherlich die jjk-webinnovations-container CSS-Klasse vergessen
			: document.forms[formId];
	const form = new JJK.Form(formHtmlElem);

	window.addEventListener(
		'pagehide',
		evt => {
			if (evt.persisted) {
				// Wenn die aktuelle Seite ausgeblendet wird und in den b/f cache kommt, submit_form_called zurücksetzen, damit nach dem Zurück-Navigieren des Browsers wieder forms abgesendet werden können.
				// der unload Event darf nicht verwendet werden, da dieser den b/f cache deaktiviert.
				window.submit_form_called = false;
			}
		},
		{ once: true }
	);

	form.Submit(action);
}

function set_before_submit(formId, func, append) {
	if (!window.form_before_submit) {
		window.form_before_submit = new Array();
	}
	if (append && window.form_before_submit[formId]) {
		const oldFunc = window.form_before_submit[formId];
		window.form_before_submit[formId] = function () {
			if (oldFunc.apply(this, arguments) === false) {
				return false;
			}
			return func.apply(this, arguments);
		};
	} else {
		window.form_before_submit[formId] = func;
	}
}

function set_before_submit_async(formId, func, append) {
	if (!window.form_before_submit_async) {
		window.form_before_submit_async = [];
	}
	if (append && window.form_before_submit_async[formId]) {
		window.form_before_submit_async[formId].push(func);
	} else {
		window.form_before_submit_async[formId] = [func];
	}
}

function isMobileBrowser() {
	const ua = navigator.userAgent;
	return !!(
		ua.match(/Android/i) ||
		ua.match(/webOS/i) ||
		ua.match(/Opera Mini/i) ||
		ua.match(/iPhone/i) ||
		ua.match(/iPad/i) ||
		ua.match(/iPod/i) ||
		ua.match(/BlackBerry/i) ||
		ua.match(/IEMobile/i) ||
		ua.match(/Windows Phone/i)
	);
}

JJK.Form = class {
	/**
	 * @param {HTMLFormElement} frm -
	 */
	constructor(frm) {
		/** @type {HTMLFormElement} */
		this.frm = frm;
	}

	GetAction(actionName) {
		///	<param name="actionName" type="String"/>
		if (!actionName) {
			return this.frm.action;
		}
		const parts = this.frm.action.split('/');
		const langPos = this.GetLanguagePos(parts);
		if (langPos >= 0) {
			const actionPos = langPos + 3;
			if (parts.length < actionPos) {
				parts.push(actionName);
			} else {
				parts[actionPos] = actionName;
			}
		}
		return parts.join('/');
	}

	SetAction(actionName) {
		this.frm.action = this.GetAction(actionName);
	}

	Submit(actionName) {
		this.SetAction(actionName);
		this.frm.requestSubmit();
	}

	GetLanguagePos(parts) {
		/// <param name="parts" type="Array&lt;String&gt;"/>
		/// <returns type="Number"/>
		for (let i = 0; i < parts.length - 1; i++) {
			if (parts[i].match(/^.{2}(-.{2})?$/) != null && parts[i + 1].match(/^\d+$/) != null) {
				return i;
			}
		}
		return -1;
	}
};

JJK.Navigation = class {
	tagName = '';

	/**
	 * @param {string} tagName
	 */
	constructor(tagName) {
		this.tagName = tagName;
	}

	/**
	 * @param {string} stepName
	 * @param {string} submitFormId
	 */
	ActivateStep(stepName, submitFormId) {
		/**
		 * @param {JQuery<HTMLElement>} elem
		 */
		function aktiviereWeiterButton(elem) {
			const formId = elem.data('form');
			if (formId) {
				submitFormId = formId;
			}

			if (Array.from(elem).some(el => el.tagName === 'BUTTON')) {
				for (const el of Array.from(elem)) {
					if (el.tagName === 'BUTTON') {
						el.removeAttribute('disabled');
					} else {
						aktiviereWeiterButton($(el));
					}
				}
				return;
			}

			if (!$(this).hasClass('completed')) {
				elem.addClass('active');
				elem.removeClass('inactive');
			}

			elem.removeAttr('onclick');
			elem.off();
			elem.on('click', function () {
				submit_form(stepName, submitFormId);
			});

			elem.on('mouseover', function () {
				elem.removeClass('normalColor');
				elem.addClass('hoverColor');
			});
		}

		/**
		 * @param {JQuery<HTMLElement>} elem
		 */
		function aktiviereNavigationStep(elem) {
			const formId = elem.data('form');
			if (formId) {
				submitFormId = formId;
			}

			if (Array.from(elem).some(el => el.tagName === 'BUTTON')) {
				for (const el of Array.from(elem)) {
					if (el.tagName === 'BUTTON') {
						el.removeAttribute('disabled');
						for (const child of el.children) {
							child.classList.add('step-next-active');
							child.classList.remove('step-next-inactive');
							if (child.classList.contains('fas')) {
								child.classList.add('fa-exclamation-circle');
								child.classList.remove('fa-question-circle');
							}
						}
					} else {
						aktiviereNavigationStep($(el));
					}
				}
				return;
			}

			elem.removeAttr('onclick');
			elem.off();
			elem.on('click', function () {
				submit_form(stepName, submitFormId);
			});

			const link = elem.find('a:first');
			let linkSpans;
			if (link.length > 0) {
				link.addClass('pe-auto').removeClass('pe-none').attr('tabindex', '').attr('aria-disabled', '');
				linkSpans = link.find('span');
			} else {
				linkSpans = elem.find('span');
			}

			if (linkSpans.length > 0) {
				linkSpans.addClass('step-next-active').removeClass('step-next-inactive');
			}
		}

		aktiviereWeiterButton($(`${this.tagName}.navigation, .nav-btn`).filter(`.${stepName}`));
		aktiviereNavigationStep($('.navbox_top_button, .navbox_left_button').filter(`.${stepName}`));
	}

	/**
	 * @param {string} stepName
	 */
	DeactivateStep(stepName) {
		/**
		 * @param {JQuery<HTMLElement>} elem
		 */
		function deaktiviereWeiterButton(elem) {
			if (Array.from(elem).some(el => el.tagName === 'BUTTON')) {
				for (const el of Array.from(elem)) {
					if (el.tagName === 'BUTTON') {
						el.setAttribute('disabled', true);
					} else {
						deaktiviereWeiterButton($(el));
					}
				}
				return;
			}

			elem.removeClass('hoverColor');
			elem.off();

			const link = elem.find('a:first');
			if (link.length > 0) {
				link.addClass('pe-none').removeClass('pe-auto').attr('tabindex', '-1').attr('aria-disabled', 'true');
			}

			const linkIcon = link.find('span:first');
			if (linkIcon.length > 0) {
				linkIcon.addClass('step-next-inactive').removeClass('step-next-active');
			}
		}

		/**
		 * @param {JQuery<HTMLElement>} elem
		 */
		function deaktiviereNavigationStep(elem) {
			if (Array.from(elem).some(el => el.tagName === 'BUTTON')) {
				for (const el of Array.from(elem)) {
					if (el.tagName === 'BUTTON') {
						el.setAttribute('disabled', true);
						for (const child of el.children) {
							child.classList.remove('step-next-active');
							child.classList.add('step-next-inactive');
							if (child.classList.contains('fas')) {
								child.classList.remove('fa-exclamation-circle');
								child.classList.add('fa-question-circle');
							}
						}
					} else {
						deaktiviereNavigationStep($(el));
					}
				}
				return;
			}
			elem.off();
			const link = elem.find('a:first');
			let linkSpans;
			if (link.length > 0) {
				link.addClass('pe-none').removeClass('pe-auto').attr('tabindex', '-1').attr('aria-disabled', 'true');
				linkSpans = link.find('span');
			} else {
				linkSpans = elem.find('span');
			}

			if (linkSpans.length > 0) {
				linkSpans.addClass('step-next-inactive').removeClass('step-next-active');
			}
		}

		deaktiviereWeiterButton($(`${this.tagName}.navigation, .nav-btn`).filter(`.${stepName}`));
		deaktiviereNavigationStep($('.navbox_top_button, .navbox_left_button').filter(`.${stepName}`));
	}
};

JJK.Position = class {
	/**
	 * @param {JQuery<HTMLElement>|HTMLElement} topElement
	 * @param {JQuery<HTMLElement>|HTMLElement} movingElement
	 */
	MoveUnder(topElement, movingElement) {
		topElement = $(topElement);
		movingElement = $(movingElement);
		const offset = topElement.offset();
		offset.top += topElement.outerHeight();
		movingElement.css('top', offset.top);
		movingElement.css('left', offset.left);
	}
	/**
	 * @param {JQuery<HTMLElement>|HTMLElement} topElement
	 * @param {JQuery<HTMLElement>|HTMLElement} movingElement
	 */
	MoveLeft(topElement, movingElement) {
		topElement = $(topElement);
		movingElement = $(movingElement);
		const offset = topElement.offset();
		offset.left += topElement.outerWidth();
		movingElement.css('top', offset.top);
		movingElement.css('left', offset.left);
	}
	/**
	 * @param {JQuery<HTMLElement>} movingElement
	 * @param {number|string} top
	 * @param {number|string} left
	 */
	MoveTo(movingElement, top, left) {
		movingElement.css('top', top);
		movingElement.css('left', left);
	}
};

JJK.AjaxError = class {
	suppressError = false;

	constructor() {
		this.Init();
	}

	Init() {
		const self = this;
		$(document).ajaxError(function (event, request, settings, exception) {
			if (self.suppressError) {
				return true;
			}
			let fehlermeldung;
			if (!request.status || request.status === 0) {
				return true;
			}
			if (request.status && request.status === HttpStatusCodeFuerWebAd.LoginAjaxError) {
				console.log('Fehler beim Aufruf einer Ajax-Funktion. Der Server liefert 499 zurück. Der Navigationstep oder das MenueItem ist nicht gültig'); // eslint-disable-line no-console
				return true;
			} else {
				if (typeof exception == 'undefined' || typeof exception.handled == 'undefined') {
					fehlermeldung = Strings.AjaxFehler;
				} else {
					fehlermeldung = request.responseText;
				}
			}
			alert(fehlermeldung);
			return true;
		});
	}
};

JJK.Paging = class {
	pagingId = '';
	currentPage = 1;
	offSet = 3;
	currentPos = 0;
	pageSize = 15;
	/** @type {string|null|Function(seite: number): void} */
	gotoFunction = '';

	/**
	 * @param {Partial<JJK.Paging>} options
	 */
	constructor(options) {
		$.extend(this, options);
	}

	Init(anzahlGesamt) {
		/** @type {HTMLDivElement} */
		const pagingContainer = document.getElementById(this.pagingId);
		if (!pagingContainer) {
			throw new Error('Paging Element nicht gefunden');
		}
		const anzahlSeiten = Math.ceil(anzahlGesamt / this.pageSize);
		pagingContainer.innerHTML = '';
		let divContainer = null;
		let ul = null;
		if (isBootstrapAvailable()) {
			divContainer = document.createElement('div');
			divContainer.classList.add('d-flex', 'align-items-center');
			const nav = document.createElement('nav');
			nav.classList.add('d-inline');
			ul = document.createElement('ul');
			ul.classList.add('pagination', 'pagination-sm', 'm-0', 'ms-1');
			nav.append(ul);
			divContainer.append(nav);
			pagingContainer.append(divContainer);
		}
		if (anzahlSeiten > 0) {
			(divContainer || pagingContainer).prepend(`${Strings.CheckpointSeiten}: `);
			(ul || pagingContainer).append(this.pagingElementFor(1));
			if (this.currentPage > this.offSet + 2) {
				if (ul) {
					ul.append(this.createBootstrapEllipsisItem());
				} else {
					pagingContainer.append(' ... ');
				}
			}
			if (anzahlSeiten > 1) {
				(ul || pagingContainer).append(...this.createDynamicLinks(anzahlSeiten));
			}
		}
	}

	Reset() {
		this.currentPos = 0;
		this.currentPage = 1;
	}

	/**
	 * @param {number} anzahlSeiten Anzahl Seiten
	 * @returns {(string|HTMLAnchorElement)[]} Elemente
	 */
	createDynamicLinks(anzahlSeiten) {
		const elems = [];
		const anzahlDynamischerLinks = 2 * this.offSet + 1;
		const left =
			this.currentPage > this.offSet + 1
				? this.currentPage <= anzahlSeiten - (this.offSet + 1)
					? this.offSet
					: anzahlDynamischerLinks - (anzahlSeiten - this.currentPage)
				: this.currentPage - 1;
		const right = this.currentPage > this.offSet + 1 ? anzahlDynamischerLinks - 1 - left : anzahlDynamischerLinks - left;
		for (let i = this.currentPage - left; i <= this.currentPage + right; i++) {
			if (i > 1 && i < anzahlSeiten) {
				elems.push(this.pagingElementFor(i));
			}
		}
		if (this.currentPage + right < anzahlSeiten) {
			if (isBootstrapAvailable()) {
				elems.push(this.createBootstrapEllipsisItem());
			} else {
				elems.push(' ... ');
			}
		}
		elems.push(this.pagingElementFor(anzahlSeiten));
		return elems;
	}

	createBootstrapEllipsisItem() {
		const li = document.createElement('li');
		li.classList.add('page-item', 'disabled');
		const span = document.createElement('span');
		span.classList.add('page-link');
		span.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16"><path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>';
		li.append(span);
		return li;
	}

	/**
	 * @param {number} seitenIndex Seitenindex
	 * @returns {HTMLAnchorElement} Link
	 */
	pagingElementFor(seitenIndex) {
		const elem = document.createElement(seitenIndex !== this.currentPage ? 'a' : 'span');
		elem.classList.add(seitenIndex === this.currentPage ? 'CurrentPagingLink' : 'PagingLink');
		elem.innerText = seitenIndex;
		if (seitenIndex !== this.currentPage) {
			elem.href = `javascript:void(${this.gotoFunction}(${seitenIndex}))`;
			if (typeof this.gotoFunction == 'function') {
				elem.href = '#';
				elem.addEventListener('click', evt => {
					evt.preventDefault();
					this.gotoFunction(seitenIndex);
				});
			}
		}
		if (isBootstrapAvailable()) {
			elem.classList = [];
			elem.classList.add('page-link');
			const li = document.createElement('li');
			li.classList.add('page-item');
			if (seitenIndex === this.currentPage) {
				li.classList.add('active');
			}
			li.append(elem);
			return li;
		}
		return elem;
	}

	GoToPage(seitenNummer) {
		this.currentPage = seitenNummer;
		this.currentPos = (seitenNummer - 1) * this.pageSize;
	}
};

window.JJK.Array = window.JJK.Array || {};

JJK.Array.Clone = array => {
	const newArray = new Array(array.length);
	for (let i = 0; i < array.length; i++) {
		newArray[i] = {};
		$.extend(newArray[i], array[i]);
	}
	return newArray;
};

Array.prototype.FirstOrDefault = function (predicate) {
	for (let i = 0; i < this.length; i++) {
		if (predicate(this[i])) {
			return this[i];
		}
	}
	return null;
};

Array.prototype.ForEach = function (action) {
	for (let i = 0; i < this.length; i++) {
		action(this[i]);
	}
};

Array.prototype.Clone = function () {
	const newArray = new Array(this.length);
	for (let i = 0; i < this.length; i++) {
		newArray[i] = {};
		$.extend(newArray[i], this[i]);
	}
	return newArray;
};

Array.prototype.HasValue = function (element) {
	for (let i = 0; i < this.length; i++) {
		if (element === this[i]) {
			return true;
		}
	}
	return false;
};
function ArrayHasValue(array, element) {
	return Array.prototype.HasValue.call(array, element);
}

Array.prototype.Add = function (element) {
	this.push(element);
};

Array.prototype.Remove = function (element) {
	for (let i = 0; i < this.length; i++) {
		// ReSharper disable once CoercedEqualsUsing
		// eslint-disable-next-line eqeqeq
		if (this[i] == element) {
			this.splice(i, 1);
			break;
		}
	}
};

window.JJK.UI = window.JJK.UI || {};

JJK.UI.SetVisible = function (selector, visible) {
	$(selector).css('display', visible ? 'block' : 'none');
	$(selector).css('visibility', visible ? 'visible' : 'hidden');
};

JJK.UI.ContextMenue = class {
	menuSelector = '#actionChangeStatus';
	checkpointVarName = '';

	constructor() {
		$(document).on('click', () => {
			$(this.menuSelector).hide();
		});
	}
	/**
	 * @returns {HTMLElement|null|undefined}
	 */
	get menu() {
		return this.menuSelector.trim() ? document.querySelector(this.menuSelector) : null;
	}
	ClearMenu() {
		$(this.menuSelector).empty();
	}
	/**
	 * @param {string} jscript
	 * @param {string} text
	 */
	AddMenu(jscript, text) {
		$(this.menuSelector).append(`<a href="javascript:${this.checkpointVarName}.${jscript}">${text}</a>`);
	}
	/**
	 * @param {Function} callback
	 * @param {string} text
	 */
	AddMenuPropper(callback, text) {
		const link = document.createElement('a');
		link.href = 'javascript:void(0)';
		link.textContent = text;
		link.addEventListener('click', evt => {
			evt.preventDefault();
			callback();
		});
		this.menu?.append(link);
	}
};

JJK.UrlHelper = class {
	_delegateMapPostVariables = null;
	constructor(options) {
		$.extend(this, options);
	}

	PostVarsForChangedItems(items) {
		const geaenderte = {};
		let j = 0;
		for (let i = 0; i < items.length; i++) {
			const item = items[i];
			if (item._changed === true) {
				const postVars = this._ConvertToPostVars(this._delegateMapPostVariables(item), j, 'aenderungen');
				for (let pv in postVars) {
					if (!Object.prototype.hasOwnProperty.call(postVars, pv)) {
						continue;
					} // siehe: https://eslint.org/docs/rules/guard-for-in
					geaenderte[pv] = postVars[pv];
				}
				j++;
			}
		}
		return geaenderte;
	}
	_ConvertToPostVars(geandert, row, prefix) {
		const postVars = {};
		for (let r in geandert) {
			if (typeof r != 'function') {
				const name = `${prefix}[${row}].${r}`;
				postVars[name] = geandert[r];
			}
		}
		return postVars;
	}
};

JJK.SessionAliveKeeper = class {
	url = '';
	interval = 30;

	constructor(options) {
		$.extend(this, options);
		this.Init();
	}

	Init() {
		window.setInterval(() => window.sessionKeeper.KeepSessionAlive(), parseInt(this.interval, 10));
	}
	KeepSessionAlive() {
		fetch(this.url, { method: 'POST', referrerPolicy: 'no-referrer', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
	}
};

JJK.Bind = function (scope, fn) {
	const args = new Array();
	for (let i = 2; i < arguments.length; i++) {
		args.push(arguments[i]);
	}
	return function () {
		const allArgs = new Array();
		for (let i = 0; i < args.length; i++) {
			allArgs.push(args[i]);
		}
		for (let i = 0; i < arguments.length; i++) {
			allArgs.push(arguments[i]);
		}
		fn.apply(scope, allArgs);
	};
};

JJK.BindAndAddCallerThis = function (scope, fn) {
	const args = new Array();
	for (let i = 2; i < arguments.length; i++) {
		args.push(arguments[i]);
	}
	return function () {
		const allArgs = new Array();
		for (let i = 0; i < args.length; i++) {
			allArgs.push(args[i]);
		}
		allArgs.push(this);
		for (let i = 0; i < arguments.length; i++) {
			allArgs.push(arguments[i]);
		}
		fn.apply(scope, allArgs);
	};
};

JJK.AsyncMethod = function (scope, fn, time) {
	if (time === undefined) {
		time = 0;
	}
	const timer = window.setTimeout(function () {
		window.clearTimeout(timer);
		fn.apply(scope);
	}, time);
};

JJK.IsFunc = function (obj) {
	return obj && obj.call && obj.apply;
};

JJK.MakeBoolean = function (value) {
	if (value === null || value === undefined) {
		return false;
	}
	if (typeof value == 'boolean') {
		return value;
	}
	if (typeof value == 'string') {
		if (value.toLowerCase() === 'true') {
			return true;
		}
		return false;
	}
	if (typeof value == 'number') {
		return value !== 0;
	}
	if (typeof value == 'object') {
		return JJK.MakeBoolean(String(value));
	}

	return value ? true : false;
};

String.prototype.toBool = function () {
	return JJK.MakeBoolean(`${this}`);
};

JJK.UI.ScrimmedMessage = class {
	scrimId = '';
	message = '';
	image = '';
	clickCallback = '';

	constructor(image, message, id, clickCallback) {
		this.scrimId = id || 'scrimmed_message';
		this.messageLayerId = `${this.scrimId}_layer`;
		this.message = message;
		this.image = image;
		this.clickCallback = clickCallback;
	}

	_appendScrim(message) {
		if ($(`#${this.scrimId}`).length === 0) {
			const scrimDiv = `<div role="alert" id="${this.scrimId}" class="wb_scrim"></div>`;
			$('body').append(scrimDiv);
			if (typeof this.clickCallback === 'function') {
				$(`#${this.scrimId}`).on('click', () => {
					this.clickCallback();
				});
			}
			$(`#${this.scrimId}`).append(`<div id="${this.messageLayerId}" class="wb_scrim_content">${this.image}<br />${message || this.message}</div>`);
		}
	}

	show(message) {
		this._appendScrim(message);
		$(`#${this.scrimId}`).show();
	}

	hide() {
		$(`#${this.scrimId}`).hide();
	}
};

// Begin JJK-Runtime-Patch-Facility *********************************************************************************************************

JJK.callSuper = function (name, args) {
	const fnc = this._overridenMethods[name];
	if (!fnc) {
		return undefined;
	}
	return fnc.apply(this, args);
};

JJK.overrideMethod = function (fnc, replacement) {
	if (fnc === undefined) {
		return;
	}

	this._overridenMethods[fnc] = this[fnc];
	this[fnc] = replacement;
};

JJK.subClass = function (patches) {
	this.callSuper = JJK.callSuper;
	this.overrideMethod = JJK.overrideMethod;
	this._overridenMethods = {};

	for (let prop in patches) {
		if (!Object.prototype.hasOwnProperty.call(patches, prop)) {
			continue;
		} // siehe: https://eslint.org/docs/rules/guard-for-in
		this.overrideMethod(prop, patches[prop]);
	}
};

// Begin JJK-End-Patch-Facility *********************************************************************************************************

JJK.backDisabled = function (formId) {
	const selector = `#${formId} `;

	function doBackUp() {
		if ($(`.${this.name}input:hidden`).length > 0) {
			return;
		}
		$(selector).append(`<input type="hidden" name="${this.name}" value="${$(this).val()}" />`);
	}

	$(`${selector}input:disabled`).each(doBackUp);
	$(`${selector}select:disabled`).each(doBackUp);
};

JJK.TableHelper = class {
	GetSelectedAuftragID(td) {
		let selectedAuftragId = null;
		const tr = $(td).parent();
		const id = tr.prop('id');
		if (id) {
			selectedAuftragId = id.split('_')[1];
		}
		return selectedAuftragId;
	}
};

JJK.PagingHelper = class {
	currentPage = 1;
	currentPos = 0;
	pageSize = 2;
	offSet = 3;
	varName = '';
	/** @type {Function(seite: number): void|null} */
	gotoPageFunc = null;

	/**
	 * @param {Partial<JJK.PagingHelper>} options
	 */
	constructor(options) {
		$.extend(this, options);
	}

	SetPaging(anzahlGesamt, varName) {
		this.varName = varName;
		/** @type {HTMLDivElement} */
		let pagingContainer = document.getElementById('paging');
		if (!pagingContainer) {
			throw new Error('Paging Element nicht gefunden');
		}
		const anzahlSeiten = Math.ceil(anzahlGesamt / this.pageSize);

		pagingContainer.innerHTML = '';
		let divContainer = null;
		let ul = null;
		if (isBootstrapAvailable()) {
			divContainer = document.createElement('div');
			divContainer.classList.add('d-flex', 'align-items-center');
			const nav = document.createElement('nav');
			nav.classList.add('d-inline');
			ul = document.createElement('ul');
			ul.classList.add('pagination', 'pagination-sm', 'm-0', 'ms-1');
			nav.append(ul);
			divContainer.append(nav);
			pagingContainer.append(divContainer);
		}
		if (anzahlSeiten > 0) {
			(divContainer || pagingContainer).prepend(`${Strings.CheckpointSeiten}: `);
			(ul || pagingContainer).append(this.pagingElementFor(1));
			if (this.currentPage > this.offSet + 2) {
				if (ul) {
					ul.append(this.createBootstrapEllipsisItem());
				} else {
					pagingContainer.append(' ... ');
				}
			}
			if (anzahlSeiten > 1) {
				(ul || pagingContainer).append(...this.createDynamicLinks(anzahlSeiten));
			}
		}
	}

	/**
	 * @param {number} anzahlSeiten Anzahl Seiten
	 * @returns {(string|HTMLAnchorElement)[]} Elemente
	 */
	createDynamicLinks(anzahlSeiten) {
		const elems = [];
		const anzahlDynamischerLinks = 2 * this.offSet + 1;
		const left =
			this.currentPage > this.offSet + 1
				? this.currentPage <= anzahlSeiten - (this.offSet + 1)
					? this.offSet
					: anzahlDynamischerLinks - (anzahlSeiten - this.currentPage)
				: this.currentPage - 1;
		const right = this.currentPage > this.offSet + 1 ? anzahlDynamischerLinks - 1 - left : anzahlDynamischerLinks - left;
		let i = -1;
		for (i = this.currentPage - left; i <= this.currentPage + right; i++) {
			if (i > 1 && i < anzahlSeiten) {
				elems.push(this.pagingElementFor(i));
			}
		}
		if (i < anzahlSeiten) {
			if (isBootstrapAvailable()) {
				elems.push(this.createBootstrapEllipsisItem());
			} else {
				elems.push(' ... ');
			}
		}
		elems.push(this.pagingElementFor(anzahlSeiten));
		return elems;
	}

	createBootstrapEllipsisItem() {
		const li = document.createElement('li');
		li.classList.add('page-item', 'disabled');
		const span = document.createElement('span');
		span.classList.add('page-link');
		span.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16"><path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>';
		li.append(span);
		return li;
	}

	/**
	 * @param {number} seitenIndex Seitenindex
	 * @returns {HTMLAnchorElement} Link
	 */
	pagingElementFor(seitenIndex) {
		const elem = document.createElement(seitenIndex !== this.currentPage ? 'a' : 'span');
		elem.classList.add(seitenIndex === this.currentPage ? 'CurrentPagingLink' : 'PagingLink');
		elem.innerText = seitenIndex;
		if (seitenIndex !== this.currentPage) {
			elem.href = `javascript:void(${this.varName}.GoToPage(${seitenIndex}))`;
			if (typeof this.gotoPageFunc == 'function') {
				elem.href = '#';
				elem.addEventListener('click', evt => {
					evt.preventDefault();
					this.gotoPageFunc(seitenIndex);
				});
			}
		}
		if (isBootstrapAvailable()) {
			elem.classList = [];
			elem.classList.add('page-link');
			const li = document.createElement('li');
			li.classList.add('page-item');
			if (seitenIndex === this.currentPage) {
				li.classList.add('active');
			}
			li.append(elem);
			return li;
		}
		return elem;
	}

	SetNextPage(seitenNummer) {
		this.SetCurrentPage(seitenNummer);
		this.SetCurrentPos((seitenNummer - 1) * this.pageSize);
	}

	SetCurrentPos(currentPos) {
		this.currentPos = currentPos;
	}

	GetCurrentPos() {
		return this.currentPos;
	}

	GetCurrentPage() {
		return this.currentPage;
	}

	SetCurrentPage(currentPage) {
		this.currentPage = currentPage;
	}

	GetPageSize() {
		return this.pageSize;
	}
};

JJK.cleanUrl = function (url) {
	return url.replace(/([^\?]*)\?.*/i, '$1'); // eslint-disable-line no-useless-escape
};

JJK.GetFileExt = function (allowContentTypes, custumSeperator, custumPrefix) {
	let fileExt = '';
	const seperator = custumSeperator ? custumSeperator : ',';
	const prefix = custumPrefix ? custumPrefix : '';
	for (let key in allowContentTypes) {
		if (!Object.prototype.hasOwnProperty.call(allowContentTypes, key)) {
			continue;
		} // siehe: https://eslint.org/docs/rules/guard-for-in
		const value = allowContentTypes[key];
		if (typeof value == 'string') {
			if (value.substring(0, 1) === '.') {
				fileExt = fileExt + prefix + value + seperator;
			}
		}
	}
	return $.trim(fileExt.substring(0, fileExt.length - 1));
};

JJK.ResizeHelper = class {
	subtrahendFuerAdDesignerCanvasHeight = 240;
	minimaleAdDesignerCanvasHeight = 300;
	resizeFunc = null;
	initFunc = null;
	initDone = false;
	adDesignerCanvasHeight = null;

	init(wbContentBoxHeightUrl) {
		this.wbContentBoxHeightUrl = wbContentBoxHeightUrl;
		let width = null;
		let height = null;
		let timer = undefined;
		$(window).on('resize', () => {
			if (width === $(window).width() && height === $(window).height()) {
				return;
			}
			width = $(window).width();
			height = $(window).height();
			if (timer) {
				window.clearTimeout(timer);
			}
			timer = window.setTimeout(() => {
				window.clearTimeout(timer);
				timer = undefined;
				this._resize();
			}, 200);
		});
		if (this.initFunc) {
			this.initFunc();
		}
		this.initDone = true;
		this._resize();
	}
	_resize() {
		// Nur wenn alle verwerteten Elemente vorhanden sind (-> nur im alten Design):
		if ($('.wb_maincontainer').length && $('.wb_headbox').length && $('.wb_footbox').length && $('.wb_contentbox,.wb_contentbox_notopnav,.wb_contentbox_nonav').length) {
			const maincontainer = $('.wb_maincontainer');
			const headAndFootHeight = $('.wb_headbox').outerHeight() + $('.wb_footbox').outerHeight();
			const contentBox = $('.wb_contentbox,.wb_contentbox_notopnav,.wb_contentbox_nonav');
			const contentBoxPaddingHeight = contentBox.outerHeight() - contentBox.height();
			let maincontainerBorder = parseInt(maincontainer.css('border-top-width'), 10) + parseInt(maincontainer.css('border-bottom-width'), 10);
			if (isNaN(maincontainerBorder)) {
				maincontainerBorder = 0;
			}
			const heightForContentBox = Math.max($(window).height() - (headAndFootHeight + contentBoxPaddingHeight + maincontainerBorder), 0);
			this.adDesignerCanvasHeight = Math.max(heightForContentBox - this.subtrahendFuerAdDesignerCanvasHeight, this.minimaleAdDesignerCanvasHeight);
			contentBox.css('min-height', heightForContentBox);
			$.post(this.wbContentBoxHeightUrl, { WbContentBoxHeight: heightForContentBox, AdDesignerCanvasHeight: this.adDesignerCanvasHeight });
		}
		if (this.resizeFunc) {
			this.resizeFunc(this.adDesignerCanvasHeight);
		}
	}
	setOnResizeFunc(resizeFunc) {
		this.resizeFunc = resizeFunc;
		if (this.adDesignerCanvasHeight) {
			this.resizeFunc(this.adDesignerCanvasHeight);
		}
	}
	setOnInitFunc(initFunc) {
		if (this.initDone) {
			initFunc();
			return;
		}
		this.initFunc = initFunc;
	}
};

function equal_height($jqSelector) {
	'use strict';
	let minHeight = 0;
	$($jqSelector)
		.css('min-height', 0)
		.each(function () {
			if ($(this).height() > minHeight) {
				minHeight = $(this).height();
			}
		})
		.css('min-height', minHeight);
}

function scroll_to_weiter() {
	'use strict';
	scroll_to_element('.button.Next', 800, true);
}
function scroll_to_element(elem, animateDuration, nurNachUnten, forceTop) {
	/// <summary>Scrollt zu einem bestimmten Element auf der Seite, wenn es vorhanden und nicht im Viewport ist</summary>
	/// <param name="elem">Selector-String des Elements zu dem gescrollt werden soll</param>
	/// <param name="animateDuration">Anzahl der Millisekunden, die zur Animation des Scrollens verwendet werden soll (Default: 800)</param>
	/// <param name="nurNachUnten">Gibt an, ob nur nach unten gescrollt werden soll, oder auch nach oben (Default: true)</param>
	/// <param name="forceTop">Immer zum Beginn des Elements scrollen (nurNachUnten wird ignoriert) (Default: false)</param>
	'use strict';
	if (typeof animateDuration == 'undefined') {
		animateDuration = 800;
	}
	if (typeof nurNachUnten == 'undefined') {
		nurNachUnten = true;
	}
	if (typeof forceTop == 'undefined') {
		forceTop = false;
	}
	const $elem = $(elem).filter(':visible');
	if ($elem.length) {
		const windowHeight = $(window).innerHeight();
		const scrollTop = $(document).scrollTop();
		const scrollBottom = scrollTop + windowHeight;
		const elemHeight = $elem.outerHeight();
		const elemTop = $elem.offset().top;
		const elemBottom = elemTop + elemHeight;

		if (forceTop) {
			$('html,body').animate({ scrollTop: elemTop - 5 - ($('header').outerHeight() || 0) }, animateDuration);
		} else {
			if (elemBottom > scrollBottom) {
				$('html,body').animate({ scrollTop: elemBottom - windowHeight + 5 }, animateDuration);
			} else if (!nurNachUnten && elemTop < scrollTop) {
				$('html,body').animate({ scrollTop: elemTop - 5 - ($('header').outerHeight() || 0) }, animateDuration);
			}
		}
	}
}

/**
 * @description Platzhalter für die Funktion aus convert2BootstrapCheckboxOrRadiobutton.js. Diese hier macht überhaupt nichts.
 * @param {string} elem Selector-String für ein form-, label- oder input-Element. Bei allen anderen wird nichts gemacht.
 * @param {string} type (optional) Typ des Controls. Wird nur verwendet wenn elem ein label-Element ist. <br /> Wenn nicht übergeben oder null, wird es automatisch ermittelt
 * @param {string} input (optional) Input-Element, dass zum Label gehört. Wird nur verwendet wenn elem ein label-Element ist. <br /> Wenn nicht übergeben oder null, wird es aufgrund des for-Attributs des Labels ermittelt.
 * @returns {void}
 */
function convert2BootstrapCheckboxOrRadiobutton(elem, type, input) {
	// eslint-disable-line no-unused-vars
	// Diese Funktion ist nur dafür da, um sie in jedem Design ohne JS-Fehler aufrufen zu können.
	// Im Responsive-Design wird diese mit der convert2BootstrapCheckboxOrRadiobutton.js überschrieben
}
function convert2BootstrapCheckboxOrRadiobutton_geladen() {
	return false;
}

function isBootstrapAvailable() {
	return typeof window.bootstrap !== 'undefined' ? true : false;
}

function setTooltips() {
	if (isMobileBrowser()) {
		$('.questionmark').each(function () {
			$(this).attr('data-original-title', '');
		});

		$('.questionmark').popover({
			trigger: 'manual',
			container: '.jjk-webinnovations-container',
		});
		$('body').on('click', function (e) {
			$('.questionmark').popover('hide');
			const evt = e.originalEvent || e; // originalEvent ist nicht immer vorhanden (bspw. mobil)
			if ($(evt.target).hasClass('questionmark')) {
				$(evt.target).popover('show');
			}
		});
	} else {
		$('.questionmark').tooltip({ container: '.jjk-webinnovations-container' });
	}
}

function createDialogTemplate(dialogName, dialogTitle, dialogGroß) {
	let dialogHtml = '';
	const dialogGroßCss = dialogGroß ? 'modal-lg modal-lg-jjk' : '';
	dialogHtml += `<div id="dialog_${dialogName}" class="modal" role="dialog">`;
	dialogHtml += `     <div class="modal-dialog ${dialogGroßCss}" role="document">`;
	dialogHtml += '         <div class="modal-content">';
	dialogHtml += '             <div class="modal-header">';
	if (dialogTitle) {
		dialogHtml += `                 <h5 class="modal-title hyphenate">${dialogTitle}</h5>`;
	}
	dialogHtml += '                 <button type="button" class="btn-close align-self-center" data-bs-dismiss="modal" aria-label="Schließen">';
	dialogHtml += '                 </button>';
	dialogHtml += '             </div>';
	dialogHtml += '         <div class="modal-body"></div>';
	dialogHtml += '         <div class="modal-footer d-block text-end"></div>';
	dialogHtml += '     </div>';
	dialogHtml += '</div>';
	return dialogHtml;
}

// jQuery-UI Dialoge beim Resize auf dem Bildschirm halten (Position + Größe):
$(function () {
	'use strict';
	$(window).on('resize', function () {
		$('.ui-dialog-content:visible').each(function () {
			const $dialogWidget = $(this).parent();
			const dialogOptions = $(this).dialog('option');
			let newHeight;
			let newWidth;

			// Höhe verringern, wenn höher als 90% der Fensterhöhe:
			if (dialogOptions.height > $dialogWidget.height()) {
				newHeight = Math.min(dialogOptions.height, $(window).height() * 0.9);
				$dialogWidget.height(newHeight);
			}
			// Breite verringern, wenn höher als 90% der Fensterbreite:
			if (dialogOptions.width > $dialogWidget.width()) {
				newWidth = Math.min(dialogOptions.width, $(window).width() * 0.9);
				$dialogWidget.width(newWidth);
			}
			// Falls es ein Resize-Event gibt, dieses ausführen:
			$(this).trigger('dialogresize');
			if (dialogOptions.resize) {
				dialogOptions.resize.call(this);
			}
			// Falls der Dialog außerhalb des sichtbaren bzw. außerhalb des erlaubten (margin-top/-left) Bereichs positioniert ist, dann zentriert positionieren:
			if (
				$(window).innerWidth() * 0.9 < $dialogWidget.outerWidth() + $dialogWidget.offset().left ||
				$(window).innerHeight() * 0.9 < $dialogWidget.outerHeight() + $dialogWidget.offset().top ||
				$dialogWidget.offset().left < parseInt($dialogWidget.css('margin-left') || 0, 10) ||
				$dialogWidget.offset().top < parseInt($dialogWidget.css('margin-top') || 0, 10) ||
				$dialogWidget.offset().left < 0 ||
				$dialogWidget.offset().top < 0
			) {
				$dialogWidget.position({ my: 'center', at: 'center', of: window });
			}
		});
	});
});

function inKundenRolleSchluepfen(url) {
	'use strict';
	$.ajax({
		cache: false,
		method: 'get',
		global: false, // u.A.: bei einem Fehler nicht den Standard-Alert anzeigen
		url: url,
		error: xhr => {
			let fehler = xhr.statusText;
			if (xhr.responseJSON) {
				fehler = xhr.responseJSON.fehler || xhr.responseJSON.error || JSON.stringify()(xhr.responseJSON, null, 2);
			} else if (xhr.responseText) {
				fehler = xhr.responseText.includes('</html>') ? 'Es liegen technische Probleme vor.' : xhr.responseText;
			}
			if (typeof jjk != 'undefined' && typeof jjk.bootstrapModalHelper != 'undefined') {
				jjk.bootstrapModalHelper.alert(fehler);
			} else {
				alert(fehler);
			}
		},
		success: data => {
			window.location.href = data;
		},
	});
}

$(() => {
	if (typeof jjk == 'object' && typeof jjk.wichtigsteAlertsVorlesen == 'function') {
		if (!jjk.wichtigsteAlertsVorlesen()) {
			if (typeof jjk.wichtigsteAlertsVorlesen == 'function') {
				jjk.fokusiereErstesFehlerhaftesFeld();
			}
		}
	}

	if (isBootstrapAvailable()) {
		setTooltips();
	}

	/** @type {HTMLElement|undefined} */
	const headerContainer = document.querySelector('#header-container');
	/** @type {HTMLDivElement|undefined} */
	const content = document.querySelector('#content');
	if (headerContainer && content) {
		const rect = headerContainer.getBoundingClientRect();
		const style = window.getComputedStyle(headerContainer);
		content.style.scrollMarginTop = `calc(${rect.height}px + ${style.marginTop} + ${style.marginBottom} + 2lh)`;
	}

	const aufklappMenue = document.getElementById('jjk-main-navbar-aufklappmenue');
	if (aufklappMenue) {
		const mainNav = aufklappMenue.querySelector('#main-nav');
		if (mainNav) {
			const elemsOhneId = [];
			const verlagsMaIds = [
				'mainnav_Checkpoint',
				'mainnav_KundenCheckpoint',
				'mainnav_VerkaufsbueroUebersicht',
				'mainnav_BenutzerStatusAendern',
				'mainnav_AuswahlDesKunden',
				'mainnav_Chart',
				'mainnav_Emails',
				'mainnav_AboCheckpoint',
				'mainnav_VorschaltseitenEditor',
				'mainnav_TemplateEditor',
			];
			const verlagsMaItems = [];
			for (const elem of Array.from(mainNav.children)) {
				if (!elem.id) {
					elemsOhneId.push(elem);
				} else if (verlagsMaIds.includes(elem.id)) {
					verlagsMaItems.push(elem);
				}
			}
			mainNav.prepend(...verlagsMaItems);
			mainNav.prepend(...elemsOhneId);
			if ('kunde' in window && typeof window.kunde.aufklapp == 'function') {
				window.kunde.aufklapp(mainNav);
			}
		}
	}

	if ($.datepicker) {
		$.datepicker.setDefaults({
			beforeShow: (elem, inst) => {
				window.setTimeout(() => {
					const zIndex = Number(inst.dpDiv[0].style.zIndex);
					if (isNaN(zIndex)) {
						inst.dpDiv[0].style.zIndex = 2;
					} else {
						inst.dpDiv[0].style.zIndex = zIndex + 1;
					}
				}, 0);
			},
		});
	}

	if (!(parseInt(document.documentElement.dataset.passwordShowTimeout, 10) < 0)) {
		/**
		 * @param {HTMLInputElement} input
		 * @param {HTMLButtonElement} switcher
		 */
		const showPassword = (input, switcher) => {
			input.type = 'text';
			switcher.innerHTML = '<i class="far fa-eye-slash"></i><span class="visually-hidden">Passwort verstecken</span>';
		};

		/**
		 * @param {HTMLInputElement} input
		 * @param {HTMLButtonElement} switcher
		 */
		const hidePassword = (input, switcher) => {
			input.type = 'password';
			switcher.innerHTML = '<i class="far fa-eye"></i><span class="visually-hidden">Passwort anzeigen</span>';
		};

		/**
		 * @param {HTMLInputElement} input
		 */
		const clearPasswordHideTimeout = input => {
			if (parseInt(document.documentElement.dataset.passwordShowTimeout, 10) <= 0) {
				return;
			}
			if (input.dataset.timeoutId) {
				window.clearTimeout(+input.dataset.timeoutId);
			}
		};

		/**
		 * @param {HTMLInputElement} input
		 * @param {HTMLButtonElement} switcher
		 */
		const resetPasswordHideTimeout = (input, switcher) => {
			if (parseInt(document.documentElement.dataset.passwordShowTimeout, 10) <= 0) {
				return;
			}
			clearPasswordHideTimeout(input);
			input.dataset.timeoutId = window.setTimeout(
				() => {
					hidePassword(input, switcher);
				},
				(parseInt(document.documentElement.dataset.passwordShowTimeout, 10) || 10) * 1000
			);
		};

		for (const input of document.querySelectorAll('input[type="password"]')) {
			if (window.location.origin === 'http://localhost:5075') {
				if (!input.getAttribute('autocomplete')) {
					import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
						new JjkToast({
							toastClass: 'text-bg-danger',
							closeButtonClass: 'btn-close-white',
							body: `Passwort-Feld hat keine "autocomplete"-Angabe: ${document.querySelector(`label[for="${input.id}"]`)?.innerText || input.id || input.placeholder || input.name}`,
							delay: -1,
						}).show();
					});
				}
			}
			if (input.parentElement.classList.contains('form-floating')) {
				const parent = input.parentElement;
				const switcher = document.createElement('button');
				switcher.type = 'button';
				switcher.innerHTML = '<i class="far fa-eye"></i><span class="visually-hidden">Passwort anzeigen</span>';
				switcher.classList.add('button-as-div');
				parent.classList.add('mit-passwort-switcher');
				parent.querySelector('input').after(switcher);
				switcher.addEventListener('click', evt => {
					evt.preventDefault();
					evt.stopPropagation();
					if (input.type === 'password') {
						showPassword(input, switcher);
						resetPasswordHideTimeout(input, switcher);
					} else {
						clearPasswordHideTimeout(input);
						hidePassword(input, switcher);
					}
				});
				input.addEventListener('input', () => {
					resetPasswordHideTimeout(input, switcher);
				});
			}
		}
	}

	if (window.location.origin === 'http://localhost:5075' && (jjk?.design?.IsModern ?? false)) {
		const labelsOhneForInFormFloating = document.querySelectorAll('.form-floating label:not([for])');
		if (labelsOhneForInFormFloating.length) {
			import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
				for (const label of labelsOhneForInFormFloating) {
					const input = label.parentElement.querySelector('input,select,textarea');
					new JjkToast({
						toastClass: 'text-bg-danger',
						closeButtonClass: 'btn-close-white',
						body: `Label nicht mit Input verbunden: ${input.id || input.placeholder || input.name}`,
						delay: -1,
					}).show();
				}
			});
		}

		const falscheWeiterZurueckNavButtons = Array.from(document.querySelectorAll('.next, .previous, .Next, .Previous')).filter(elem => elem.tagName !== 'BUTTON');
		if (falscheWeiterZurueckNavButtons.length > 0) {
			import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
				for (const elem of falscheWeiterZurueckNavButtons) {
					new JjkToast({
						toastClass: 'text-bg-danger',
						closeButtonClass: 'btn-close-white',
						body: `alten Nav-Button gefunden: ${elem.textContent}`,
						delay: -1,
					}).show();
				}
			});
		}
		if (document.querySelector('.relativenav, .navBottomRight, .navTopRight')) {
			import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
				new JjkToast({
					toastClass: 'text-bg-danger',
					closeButtonClass: 'btn-close-white',
					body: 'alte Nav gefunden!',
					delay: -1,
				}).show();
			});
		}

		setTimeout(() => {
			// Ausführung verzögern, um die ID-Manipulation (bspw. bei Abos) abzuwarten
			const elementeMitIds = Array.from(document.querySelectorAll('[id]'));
			const doppelteIds = elementeMitIds.filter(elem => elementeMitIds.filter(elem2 => elem2.id === elem.id).length > 1);
			if (doppelteIds.length > 0) {
				import('../ts/classes/toast.js').then(({ default: JjkToast }) => {
					const idAnzahl = {};
					doppelteIds.forEach(elem => {
						idAnzahl[elem.id] = (idAnzahl[elem.id] || 0) + 1;
					});
					for (const [id, anzahl] of Object.entries(idAnzahl)) {
						new JjkToast({
							toastClass: 'text-bg-danger',
							closeButtonClass: 'btn-close-white',
							body: `${anzahl} Elemente mit der ID<br><span class="font-monospace">${id}</span>`,
							delay: -1,
						}).show();
					}
				});
			}
		}, 0);
	}
});
